import { Box, Card, CardContent, CardHeader, Grid } from "@mui/material";
import ShareBars from "../global/charts/ShareBars";
import LineChart from "../global/LineChart";

const CNTProfile = ({ dataLine, dataPie, totalVolume }) => {
  return (
    <Card elevation={0}>
      <CardHeader title="Trading volume ($)" sx={{ pb: 0 }} />
      <CardContent>
        <Grid container>
          <Grid item xs={12} lg={8}>
            <LineChart data={dataLine} />
          </Grid>
          <Grid item xs={12} lg={4}>
            <Box sx={{ pl: { lg: 3 }, pt: { xs: 3, lg: 0 } }}>
              <ShareBars data={dataPie} total={totalVolume} title="Latest volume" />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default CNTProfile;
